/* team-knowledge-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./team-knowledge-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { getTypedJSONResultData } from '../../ai-answer-dialog/utils/getTypedJSONResultData';
import { useAnalytics, useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { messages } from '../../messages';
import { AIDisclaimerAndFeedback } from '../../v2/common/ui/ai-disclaimer-and-feedback';
import { onKnowledgeCardShown } from '../analytics';
import { getEditDistanceRatio } from '../gql/hydrate-team-card';
import { KnowledgeCardsBody } from '../knowledge-cards-body';
import { KnowledgeCardsHeader } from '../knowledge-cards-header';
import { SeparatorLine, SeparatorLineRefresh } from '../separator-line';
import { KnowledgeCardsIntentType } from '../types';
import { TeamCardBody } from './team-card-body';
import { TeamCardHeader } from './team-card-header';
var CardContainerStyles = {
  default: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
  refresh: "_2rko12b0 _zulppxbi _189ee4h9 _1dqonqa1 _1h6d1l7x _ca0qpxbi _n3tdpxbi",
  disclaimer: "_19bvpxbi _u5f3pxbi"
};
export var TeamKnowledgeCard = /*#__PURE__*/memo(function (_ref) {
  var _data$recentActivity, _data$members;
  var onFMPReached = _ref.onFMPReached;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    currentUserId = _useAIAnswerContext.userDetails.id;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var answerString = commonAttributes.answerString,
    query = commonAttributes.query;
  var data = getTypedJSONResultData(answerString).parsedResult;
  var editDistanceRatio = getEditDistanceRatio(query, data.name);
  useEffect(function () {
    if (data.id) {
      onFMPReached === null || onFMPReached === void 0 || onFMPReached();
      fireSAINUsageEvent({
        commonAttributes: commonAttributes
      });
      fireAnalyticsEvent(onKnowledgeCardShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        cardType: KnowledgeCardsIntentType.TEAM,
        extraAttributes: {
          editDistance: editDistanceRatio
        }
      })));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var showKnowledgeCardBody = (((_data$recentActivity = data.recentActivity) === null || _data$recentActivity === void 0 ? void 0 : _data$recentActivity.length) || 0) > 0 || (((_data$members = data.members) === null || _data$members === void 0 ? void 0 : _data$members.length) || 0) > 0;
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.200"
  }, fg('enable_team_site_assignment') && /*#__PURE__*/React.createElement(SectionMessage, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_dialog_teams_not_found_message), ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://support.atlassian.com/platform-experiences/docs/understanding-team-visibility/"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_answer_dialog_teams_not_found_message_link))), data.id ? fg('kd_people_cards_update') ? /*#__PURE__*/React.createElement(Stack, {
    xcss: CardContainerStyles.refresh,
    testId: "team-knowledge-card"
  }, /*#__PURE__*/React.createElement(TeamCardHeader, {
    name: data.name,
    avatarUrl: data.avatarUrl,
    profileUrl: data.url,
    teamId: data.id
  }), showKnowledgeCardBody && /*#__PURE__*/React.createElement(SeparatorLineRefresh, null), /*#__PURE__*/React.createElement(Box, null, showKnowledgeCardBody && /*#__PURE__*/React.createElement(TeamCardBody, {
    currentUserId: currentUserId || '',
    recentActivity: data.recentActivity,
    recommendedUsers: data.members,
    viewAllUrl: data.url || '',
    teamId: data.id
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: CardContainerStyles.disclaimer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: true
  })))) : /*#__PURE__*/React.createElement(Stack, {
    xcss: CardContainerStyles.default,
    testId: "team-knowledge-card"
  }, /*#__PURE__*/React.createElement(KnowledgeCardsHeader, {
    type: KnowledgeCardsIntentType.TEAM,
    name: data.name,
    avatarUrl: data.avatarUrl,
    profileUrl: data.url,
    teamId: data.id
  }), /*#__PURE__*/React.createElement(SeparatorLine, null), /*#__PURE__*/React.createElement(KnowledgeCardsBody, {
    type: KnowledgeCardsIntentType.TEAM,
    currentUserId: currentUserId || '',
    recentActivity: data.recentActivity,
    recommendedUsers: data.members,
    profileUrl: data.url || '',
    viewAllUrl: data.url || '',
    teamId: data.id
  })) : null);
});